"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _user = require("@/api/user");
var _default = exports.default = {
  directives: {
    waves: _waves.default
  },
  filters: {
    downloadUrlFilter: function downloadUrlFilter(row) {
      return 'http://dl.51find.me/20210304/index.html?token=' + row.token + '&download=' + encodeURIComponent(row.download);
    }
  },
  data: function data() {
    return {
      listLoading: false,
      list: []
    };
  },
  watch: {},
  mounted: function mounted() {},
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$channelAuthori, code, data, _channelAuthority, i;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _user.channelAuthority)();
            case 1:
              _yield$channelAuthori = _context.v;
              code = _yield$channelAuthori.code;
              data = _yield$channelAuthori.data;
              this.listLoading = false;
              if (code === 0) {
                _channelAuthority = {};
                _channelAuthority.distributor_no = '';
                for (i in data) {
                  _channelAuthority.distributor_no += data[i].distributor_no + ' ';
                  if (i === '0') {
                    _channelAuthority.link = 'http://dl.51find.me/20210304/index.html?token=' + data[i].token + '&download=' + encodeURIComponent(data[i].download);
                  } else {
                    _channelAuthority.link += '&iosToken=' + data[i].token + '&iosDownload=' + encodeURIComponent(data[i].download);
                  }
                  if (i === '0') {
                    _channelAuthority.noLink = 'http://dl.51find.me/20210907/index.html?token=' + data[i].token + '&download=' + encodeURIComponent(data[i].download);
                  } else {
                    _channelAuthority.noLink += '&iosToken=' + data[i].token + '&iosDownload=' + encodeURIComponent(data[i].download);
                  }
                }
                this.list.push(_channelAuthority);
                console.log(_channelAuthority);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }
};